export default __webpack_public_path__ + "static/media/modeling_gold.2c0d4480.png";